import React from "react";
import { useTranslation } from "react-i18next";

export const translatedModalProps = (props, t) => {    
    const { error, content } = props;  
    let modalProps = props;

    // Remove error if it exists so it can be set in the modal body with overrides    
    if (error && error?.response)
    {
        const {error, ...props} = modalProps;
        modalProps = props;     
    }

    // Remove content if it exists so it can be set in the modal body
    if ('content' in props) {
      const { content, ...props } = modalProps;
      modalProps = props
    }

    return modalProps;
}


export const isUnexpectedError = (error) => {
    if (error?.message) {
      return (
        error?.response[0]?.message?.toLowerCase().includes("please contact") ||
        error?.response[0]?.message?.toLowerCase().includes("unexpected")
      );
    }
  };
